import React, {Component} from 'react';
import $ from 'jquery';
import {AJAX, hidePreloader, on_interstate_exit, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {gTagClickEventValue} from "./frontend_script";

class EmailQuotePage extends Component {
	constructor(props) {
		super(props);
		this.onSend = this.onSend.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);

		this.state = {
			status: "quote",
			quote_firstnameError: this.props.booking_form_data.booking.quote_firstname !== undefined ? '' : 'This field is required.',
			quote_firstnameDirty: false,
			quote_lastnameError: this.props.booking_form_data.booking.quote_lastname !== undefined ? '' : 'This field is required.',
			quote_lastnameDirty: false,

			quote_firstname: this.props.booking_form_data.booking.quote_firstname !== undefined ? this.props.booking_form_data.booking.quote_firstname : '',
			quote_lastname: this.props.booking_form_data.booking.quote_lastname !== undefined ? this.props.booking_form_data.booking.quote_lastname : '',

			quote_email:  this.props.booking_form_data.booking.quote_email !== undefined ? this.props.booking_form_data.booking.quote_email : ( this.props.booking_form_data.booking.interstate_email !== undefined ? this.props.booking_form_data.booking.interstate_email : ''),
			quote_phone:  this.props.booking_form_data.booking.quote_phone !== undefined ? this.props.booking_form_data.booking.quote_phone : ( this.props.booking_form_data.booking.interstate_phone !== undefined ? this.props.booking_form_data.booking.interstate_phone : ''),
			quote_emailError: this.props.booking_form_data.booking.quote_email !== undefined ? '' : ( this.props.booking_form_data.booking.interstate_email !== undefined ? '' : 'This field is required.' ),
			quote_emailDirty: false,
			quote_phoneError: this.props.booking_form_data.booking.quote_phone !== undefined ? '' : ( this.props.booking_form_data.booking.interstate_phone !== undefined ? '' : 'This field is required.' ),
			quote_phoneDirty: false,
			validate: false,
			wrong_captcha: false
		};
	}

/*	componentDidMount() {
		if (window.bf_g_recaptcha_mode == true) {
			let gc = document.createElement('script');
			gc.src = 'https://www.google.com/recaptcha/api.js?render=' + window.bf_g_recaptcha_key;
			gc.type = 'text/javascript';
			document.getElementsByTagName('script')[0].parentNode.insertBefore(gc, document.getElementsByTagName('script')[0]);
		}
	}*/

	onBlurHandler(e) {
		let name = e.target.name + 'Dirty';
		this.setState({[name]: true});
	}

	onChangeInput(e) {
		let nameError = e.target.name + 'Error';
		if (e.target.value.length > 0) {
			this.setState({[nameError]: ''});

			if (e.target.name === 'quote_phone') {
				const re2 = /^(\+6\d{10}|0\d{9})$/;
				if (!re2.test(e.target.value)) {
					this.setState({[nameError]: 'Please enter a valid phone number.'});
				}
			}

			if (e.target.name === 'quote_email') {
				const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
				if (!re.test(String(e.target.value).toLowerCase()))
					this.setState({[nameError]: 'Please enter a valid email address.'});
			}
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	onSend(e) {
		let fields = this.props.send_quote;
		let btn = e.target;
		let form_inputs = $(btn).closest('.email-quote');
		let params = {};
		let t = this;

		let validate = true;
		let toSet = {};
		let formData = {};

		for (let item in fields) {
			let el = form_inputs.find('[name=' + fields[item] + ']');
			if (el.length) {
				params['booking[' + fields[item] + ']'] = el[0].value.trim();
				formData[fields[item]] = el[0].value.trim();
			}
			if (this.state[fields[item] + 'Error'] !== '') {
				toSet[fields[item] + 'Dirty'] = true;
				validate = false;
			}
		}

		toSet.validate = validate;
		this.setState(toSet);

		if (validate) {
			this.setState(formData);
			params.action = 'api/booking/quote';

			for (let item in this.props.booking_form_data.booking) {
				params['booking[' + item + ']'] = this.props.booking_form_data.booking[item];
			}

			params['booking[status]'] = this.state.status;

			if (this.props.booking_form_data.booking.hire == 'local') {
				// todo использовать одинаковые названия полей в поиске и здесь
				params['booking[pickup_location]'] = this.props.booking_form_data.booking.pickuplocationid;
				params['booking[return_location]'] = this.props.booking_form_data.booking.dropofflocationid;
			}

//			console.log('params', params, this.props.booking_form_data);

			if (window.bf_g_recaptcha_mode == true && typeof grecaptcha === 'object') {
				grecaptcha.ready(function() {
					grecaptcha.execute(window.bf_g_recaptcha_key, {action: 'submit'}).then(function(token) {
						params['booking[g-recaptcha-response]'] = token;
						t.sendQuote(params, t);
					});
				});
			}
			else if (window.bf_g_recaptcha_mode == true && typeof grecaptcha !== 'object') {
				navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Not init google recaptcha')+'&origin='+bf_debug_telegram_original);
			}
			else {
				this.sendQuote(params, this);
			}
		}
	}

	sendQuote(params, t) {
		AJAX(bf_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {
				hidePreloader();
				if (resp.error) {
					showPopupWithGoBack(resp.error);
				}
				else if (resp.wrong_captcha === 1) {
					t.setState({wrong_captcha: true});

					if (window.bf_g_recaptcha_mode == true)
						navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('google recaptcha score for email ' + resp.email + ': ' + resp.score)+'&origin='+bf_debug_telegram_original);
				}
				else {

					let form_data = {};

					form_data.quote_email = t.state.quote_email;
					form_data.quote_phone = t.state.quote_phone;
					form_data.quote_firstname = t.state.quote_firstname;
					form_data.quote_lastname = t.state.quote_lastname;

					t.props.handleSetBookingFormData(form_data, {}, {}, {});

					if(t.props.booking_form_data.booking.hire == 'interstate') {
						$(window).off('mouseout', on_interstate_exit);
					}

					if (resp.total) {
						try {
							gTagClickEventValue((t.props.booking_form_data.booking.hire === 'local' ? 'click_to_quote' : 'click_to_quote_interstate'),
								{
									'event_category': 'booking',
									'event_label': 'booking-quote',
									'value': parseInt(resp.total, 10)
								}
							);
						} catch (e) {
						}
						gTagClickEventValue('click',
							{
								'event_category': 'booking',
								'event_label': 'booking-quote',
								'value': parseInt(resp.total, 10)
							}
						);
						try {
							gTagClickEventValue('add_to_wishlist',
								{
									"value": parseInt(resp.total, 10),
									"currency": "AUD",
									"items": [{
										"item_name": resp.name,
										"item_category": "Website",
										"quantity": 1,
										"price": parseInt(resp.total, 10)
									}]
								}
							);
						} catch (e) {
						}
						gTagClickEventValue('add_to_wishlist',
							{
								"value": parseInt(resp.total, 10),
								"currency": "AUD",
								"items": [{
									"name": resp.name,
									"category": "Website",
									"quantity": 1,
									"price": parseInt(resp.total, 10)
								}]
							}
						);
					}

					if (resp.data)
						showPopupWithGoBack('<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png" alt="gecko" style="float:left;margin:0 20px 0 0;">Your quote has been sent to your nominated email address. Thank you for choosing to Go with the Gecko.');

					t.props.handleEmailQuote();
				}
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	onCancel() {
		this.props.handleEmailQuote();
	}

	render() {
		return (<>
			<RedirectOnlyHome />

			<div className="row justify-content-center justify-content-md-center email-quote">
				<div className="col-md-8 my-3">
					<div className="row">
						<div className={'form-group col-md-6 '+((this.state.quote_firstnameDirty && this.state.quote_firstnameError) && 'has-danger')}>
							<input className="form-control required" type="text"
								   name="quote_firstname"
								   placeholder="First Name *"
								   onChange={this.onChangeInput}
								   onBlur={this.onBlurHandler}
								   defaultValue={this.state.quote_firstname}
							/>
							{
								(this.state.quote_firstnameDirty && this.state.quote_firstnameError) &&
								<small className="form-control-feedback d-block">{this.state.quote_firstnameError}</small>
							}
						</div>
						<div className={'form-group col-md-6 '+((this.state.quote_lastnameDirty && this.state.quote_lastnameError) && 'has-danger')}>
							<input className="form-control required" type="text"
								   name="quote_lastname"
								   placeholder="Last Name *"
								   onChange={this.onChangeInput}
								   onBlur={this.onBlurHandler}
								   defaultValue={this.state.quote_lastname}
							/>
							{
								(this.state.quote_lastnameDirty && this.state.quote_lastnameError) &&
								<small className="form-control-feedback d-block">{this.state.quote_lastnameError}</small>
							}
						</div>
					</div>
					<div className="row">
						<div className={'form-group col-md-6 '+((this.state.quote_emailDirty && this.state.quote_emailError) && 'has-danger')}>
							<input className="form-control required" type="email"
								   name="quote_email"
								   placeholder="Email *"
								   onChange={this.onChangeInput}
								   onBlur={this.onBlurHandler}
								   defaultValue={this.state.quote_email}
							/>
							{
								(this.state.quote_emailDirty && this.state.quote_emailError) &&
								<small className="form-control-feedback d-block">{this.state.quote_emailError}</small>
							}
						</div>
						<div className={'form-group col-md-6 '+((this.state.quote_phoneDirty && this.state.quote_phoneError) && 'has-danger')}>
							<input className="form-control required" type="text"
								   name="quote_phone"
								   placeholder="Phone *"
								   onChange={this.onChangeInput}
								   onBlur={this.onBlurHandler}
								   defaultValue={this.state.quote_phone}
							/>
							{
								(this.state.quote_phoneDirty && this.state.quote_phoneError) &&
								<small className="form-control-feedback d-block">{this.state.quote_phoneError}</small>
							}
						</div>
					</div>
					{
						(window.bf_g_recaptcha_mode == true && this.state.wrong_captcha) && (
							<div className="row">
								<div className={'form-group col text-center'}>
									<small className="form-control-feedback d-block">Check the captcha!</small>
								</div>
							</div>
						)
					}
					<div className="row justify-content-center">
						<div className="form-group col-auto">
							<input type="button" className="btn btn-green" value="Send" onClick={this.onSend} />
						</div>
						<div className="form-group col-auto">
							<input type="button" className="btn btn-green" value="Cancel" onClick={this.onCancel} />
						</div>
					</div>
				</div>
			</div>
		</>);
	}
}

export default EmailQuotePage;